export type Translations = {
  [key: string]: { [key: string]: string };
};

export enum LocaleStateStatus {
  OK,
  PENDING,
}

export type LocaleInfo = {
  locale: string;
  longName: string;
  shortName: string;
  lcid: number;
  isRtl: boolean;
};
